/* import __COLOCATED_TEMPLATE__ from './select-method.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { PHONE_DELIVERY_METHODS } from './base';
let TwoFactorUpgradeSelectMethodComponent = (_dec = service('ember-multipassfe-client'), _class = class TwoFactorUpgradeSelectMethodComponent extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "selectedPhone", _descriptor3, this);
    _defineProperty(this, "phoneDeliveryMethods", PHONE_DELIVERY_METHODS);
    this.setSelectedPhone();
  }
  get canSendCode() {
    return this.args.selectedDetail;
  }
  get hasSmsAndOtherDetails() {
    return this.args.smsDetails?.length && (this.args.emailDetails?.length || this.args.authAppDetails?.length);
  }
  get heading() {
    // Account recovery, only one sms detail, no other details
    if (this.args.isAccountRecoveryFlow && this.args.smsDetails?.length === 1 && !this.hasSmsAndOtherDetails) {
      return this.intl.t(`${this.args.tPrefix}two_factor.upgrade.recovery.heading`);
    }
    return this.intl.t(`${this.args.tPrefix}two_factor.upgrade.select_method.heading`);
  }
  get phoneActionText() {
    if (this.multipassfeClient.canUseVoice) {
      return {
        label: this.intl.t(`${this.args.tPrefix}two_factor.upgrade.select_method.phone_voice`),
        subtext: this.intl.t(`${this.args.tPrefix}two_factor.upgrade.select_method.phone_subtext_voice`)
      };
    }
    return {
      label: this.intl.t(`${this.args.tPrefix}two_factor.upgrade.select_method.phone`),
      subtext: this.intl.t(`${this.args.tPrefix}two_factor.upgrade.select_method.phone_subtext`)
    };
  }
  get displayPhoneMenu() {
    return this.args.selectedMethod === this.args.methods.SMS && (this.multipassfeClient.canUseVoice || this.args.smsDetails?.length > 1);
  }
  setSelectedPhone() {
    if (!(this.args.selectedDetail && this.args.selectedDetail.sms)) {
      return;
    }
    for (const smsDetail of this.args.smsDetails) {
      if (smsDetail.sms.phone === this.args.selectedDetail.sms.phone) {
        this.selectedPhone = smsDetail.sms.phone;
      }
    }
  }
  onSendVerificationCode() {
    this.args.sendVerificationCode();
  }
  phoneNumberSelected(event) {
    if (!event.detail.value) {
      return;
    }
    this.selectedPhone = event.detail.value;
    for (const smsDetail of this.args.smsDetails) {
      if (smsDetail.sms.phone === this.selectedPhone) {
        this.args.setSelectedDetail(smsDetail, false);
      }
    }
  }
  detailSelected(event) {
    if (event.detail.newSelectionValue) {
      this.args.setSelectedDetail(event.detail.newSelectionValue);
    }
  }
  methodSelected(event) {
    if (event.detail.newSelectionValue) {
      // Reset selected phone/phone delivery method state when methods change
      this.selectedPhone = undefined;
      this.args.setSelectedPhoneDeliveryMethod(this.phoneDeliveryMethods.SMS);
      this.args.setSelectedMethod(event.detail.newSelectionValue);
    }
  }
  onPhoneDeliveryMethodChange(event) {
    if (event.detail.newSelectionValue) {
      this.args.setSelectedPhoneDeliveryMethod(event.detail.newSelectionValue);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedPhone", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onSendVerificationCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSendVerificationCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "phoneNumberSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "phoneNumberSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "detailSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "detailSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "methodSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "methodSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onPhoneDeliveryMethodChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onPhoneDeliveryMethodChange"), _class.prototype), _class);
export { TwoFactorUpgradeSelectMethodComponent as default };